var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { isCSR } from './domain';
import { getLocale } from '../constants';
import { isMobileView } from './mobileApp';
import { USER_CENTRICS_ADJUST_SERVICE_ID, getAdjustToken, getUserCentricsAdjustConsentValue, } from './utils';
const ADJUST_BANNER_DIV_CLASS_NAME = 'adjust-sb_banner__ttd2n';
const ADJUST_BANNER_DEFAULT_ZINDEX = 999999;
export const ADJUST_DEEPLINK = {
    DASHBOARD: 'dashboard?irclickid={irclickid}',
};
const falsyValues = {
    adjustConsent: false,
    adjustToken: '',
};
const onAdjustSmartBannerCreated = () => {
    const adjustBannerCollection = document.getElementsByClassName(ADJUST_BANNER_DIV_CLASS_NAME);
    if (adjustBannerCollection && adjustBannerCollection.length > 0) {
        const adjustBanner = adjustBannerCollection[0];
        adjustBanner.style['z-index'] = ADJUST_BANNER_DEFAULT_ZINDEX;
    }
};
const adjustSmartBannerInstance = () => __awaiter(void 0, void 0, void 0, function* () { return (yield import('@adjustcom/smart-banner-sdk')).default; });
export const isAdjustSDKReadyToInit = (_a) => {
    var props = __rest(_a, []);
    return Object.entries(props).every(([key, value]) => falsyValues[key] !== value && value !== undefined);
};
export const setAdjustDeeplink = (deeplink) => __awaiter(void 0, void 0, void 0, function* () {
    if (!deeplink)
        return;
    const { iOSDeeplinkPath, androidDeeplinkPath, context } = deeplink;
    const adjustSmartBanner = yield adjustSmartBannerInstance();
    if (iOSDeeplinkPath) {
        adjustSmartBanner.setIosDeepLinkPath(iOSDeeplinkPath);
    }
    if (androidDeeplinkPath) {
        adjustSmartBanner.setAndroidDeepLinkPath(androidDeeplinkPath);
    }
    if (context) {
        adjustSmartBanner.setContext(context);
    }
});
export const initAdjustSmartBannerSDK = (locale, deeplink) => __awaiter(void 0, void 0, void 0, function* () {
    const adjustSmartBanner = yield adjustSmartBannerInstance();
    let smartBannerOptions = {
        appToken: getAdjustToken(),
        language: getLocale(locale).langISO1,
        logLevel: 'verbose',
        onCreated: () => {
            onAdjustSmartBannerCreated();
            setAdjustDeeplink(deeplink);
        },
    };
    adjustSmartBanner.init(smartBannerOptions);
});
export const initializeAdjustWhenReady = (b2cEnableAdjustSmartBanner, locale, deeplink, isSmartBannerPage = false) => {
    var _a;
    if (!isCSR() ||
        !isMobileView() ||
        b2cEnableAdjustSmartBanner === false ||
        b2cEnableAdjustSmartBanner === undefined ||
        !isSmartBannerPage) {
        return;
    }
    let adjustConsentStatus = false;
    const userCentrics = window === null || window === void 0 ? void 0 : window['UC_UI'];
    if (userCentrics) {
        const ucServices = userCentrics === null || userCentrics === void 0 ? void 0 : userCentrics.getServicesBaseInfo();
        const adjustService = ucServices === null || ucServices === void 0 ? void 0 : ucServices.find((service) => (service === null || service === void 0 ? void 0 : service.id) === USER_CENTRICS_ADJUST_SERVICE_ID);
        adjustConsentStatus = ((_a = adjustService === null || adjustService === void 0 ? void 0 : adjustService.consent) === null || _a === void 0 ? void 0 : _a.status) || false;
    }
    if (adjustConsentStatus && adjustConsentStatus === true) {
        // adjust consent already given
        if (isAdjustSDKReadyToInit({ adjustToken: getAdjustToken() })) {
            initAdjustSmartBannerSDK(locale, deeplink);
        }
        return;
    }
    // wait for consent, if not given yet
    window.addEventListener('ucEvent', function (event) {
        if (isAdjustSDKReadyToInit({
            adjustToken: getAdjustToken(),
            adjustConsent: getUserCentricsAdjustConsentValue(event),
            ucEvent: event,
        })) {
            initAdjustSmartBannerSDK(locale, deeplink);
        }
    });
};
//# sourceMappingURL=adjustSmartBanner.js.map